import { mixins, styled } from '@bob/library'

export const SpotWrapper = styled.div<{ overlayOnHeroImage: boolean }>`
  ${mixins.margin.bottom(100)}
  ${(props: { overlayOnHeroImage: boolean }) =>
    props.overlayOnHeroImage &&
    `
  margin: -340px auto 0 auto;
  @media (max-width: 1024px) {
    margin-top: -186px;
  }
  @media (max-width: 768px) {
    margin-top: -122px;
  }
  `}
`

export type ShowableProps = {
  show: boolean
}

export const StickyWrapper = styled.div<ShowableProps>`
  position: fixed;
  z-index: 4;
  bottom: ${({ show }: ShowableProps) => (show ? '20px' : '-200px')};
  right: 7%;
  background: ${mixins.colors.grayWhite};
  ${mixins.shadows.floating};
  border-radius: 10px;
  // ${mixins.padding(20)};
  transition: 0.25s;
  .has-cart-modal & {
    bottom: -200px;
  }
`
